import { render, staticRenderFns } from "./CompBenefitsCard.vue?vue&type=template&id=ffbd5404&scoped=true"
import script from "./CompBenefitsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompBenefitsCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompBenefitsCard.vue?vue&type=style&index=0&id=ffbd5404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbd5404",
  null
  
)

export default component.exports